import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { VenueAnalysisWidgetState } from './VenueAnalysisWidgetState';
import { VenueAnalysisActionPayload } from './actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildVenueAnalysisConfigSlice } from 'widgets/venueAnalysis/store/configuration/configSlice';
import { buildVenueAnalysisComponentSlice } from 'widgets/venueAnalysis/store/component/componentSlice';

const { reducer: venueAnalysisConfigReducer } = buildVenueAnalysisConfigSlice();
const { reducer: venueAnalysisComponentReducer } =
    buildVenueAnalysisComponentSlice();

const widgetStateReducer = combineReducers<VenueAnalysisWidgetState>({
    component: venueAnalysisComponentReducer,
    config: venueAnalysisConfigReducer,
});

export const venueAnalysisWidgetsReducer = createWidgetsReducer<
    VenueAnalysisWidgetState,
    VenueAnalysisActionPayload
>(WidgetType.VENUE_ANALYSIS, widgetStateReducer);
